import React, {useEffect, useState} from 'react';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import {PtrnCampoEditableFloat} from '../../../patronTypes';
import {EditableProps} from '../campoEditableTypes';
import {getNoBorderSx, useInputStyles} from '../campoEditableUtils';
import {PtrnPropsUtil} from '../../../patronUtils';
import {numeros} from 'lib.common';

function CampoEditableFloat(
   props: {campoConfig: PtrnCampoEditableFloat} & EditableProps & {ErrorComponent?: React.ReactNode}
) {
   const {campoConfig, ...editableProps} = props;
   const classes = useInputStyles();

   const auxParam = {
      camposData: editableProps.camposData,
      campoConfig: campoConfig,
      ptrnRef: editableProps.ptrnRef,
      ruta: editableProps.ruta,
      index: editableProps.index
   };

   const [esEditable, setEsEditable] = useState(false);
   const [value, setValue] = useState(
      numeros.formatoNumeroDecimal(Number(editableProps.value), {
         cifrasDecimales: campoConfig.maxDigitosDecimales
      })
   );

   useEffect(() => {
      setValue(
         numeros.formatoNumeroDecimal(Number(editableProps.value), {
            cifrasDecimales: campoConfig.maxDigitosDecimales,
            separadorMiles: ','
         })
      );
   }, [editableProps.value]);
   const handleOnFocus: React.FocusEventHandler<HTMLInputElement> = (e) => {
      setEsEditable(true);
      setTimeout(() => e.target.select(), 0); // Asegura la selección completa del texto
   };
   const handleOnChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
      const name = e.target.name;
      let newValue = e.target.value.replace(/,/g, '');
      setEsEditable(true);
      editableProps.onChange(name, newValue, auxParam);
   };
   const handleOnBlur: React.FocusEventHandler<HTMLInputElement> = (e) => {
      const name = e.target.name;
      let newValue = e.target.value;
      if (editableProps.onBlur) {
         editableProps.onBlur(name, newValue, auxParam);
      }
      editableProps.onChange(name, value.numero, auxParam);
      setEsEditable(false);
   };
   const id = PtrnPropsUtil.genIdCampoEditable(campoConfig);
   const endAdornments = props.ErrorComponent ? (
      <InputAdornment position="end">{props.ErrorComponent}</InputAdornment>
   ) : undefined;
   return (
      <FormControl fullWidth error={Boolean(props.ErrorComponent)}>
         <InputLabel htmlFor={id}>{campoConfig.label}</InputLabel>
         <OutlinedInput
            sx={getNoBorderSx(campoConfig)}
            className={classes.classes.ceFocused}
            id={id}
            name={campoConfig.name}
            label={campoConfig.label}
            value={esEditable ? editableProps.value : value.formato}
            onChange={handleOnChange}
            onBlur={handleOnBlur}
            onFocus={handleOnFocus}
            endAdornment={endAdornments}
            fullWidth
            inputProps={{
               style: {textAlign: campoConfig.alinearTexto || 'right'}
            }}
            size="small"
         />
      </FormControl>
   );
}

export default CampoEditableFloat;
